<div class="alert alert-danger mt-2" *ngIf="bloqueado">
  <p>O uso do sistema está suspenso pois o pagamento da mensalidade não foi identificado. Caso já tenha efetuado o pagamento,
    envie o comprovante no <b> grupo de atendimento do WhatsApp</b> ou entre em contato através do WhatsApp do seu consultor
    ou aguarde liberação automática</p>
</div>
